import Vue from 'vue'
import VueRouter from 'vue-router'

// VIEWS
import Home from '../views/Home.vue'
import ArticlesList from '../views/ArticlesList'
import Article from '../views/Article'
import Academics from '../views/Academics.vue'
import Industry from '../views/Industry'
import Technologies from '../views/TechnologiesList'
import Technology from '../views/Technology'
import Services from '../views/ServicesList'
import Service from '../views/Service'
import About from '../views/About.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/news',
    name: 'ArticlesList',
    component: ArticlesList,
  },
  {
    path: '/news/:slug',
    name: 'Article',
    component: Article,
  },
  {
    path: '/academics',
    name: 'Academics',
    component: Academics,
    children: [
      {
        path: ':slug',
        name: 'AcademicsSlug',
        component: Academics,
      },
    ],
  },
  {
    path: '/industry',
    name: 'Industry',
    component: Industry,
    children: [
      {
        path: ':slug',
        name: 'IndustrySlug',
        component: Industry,
      },
    ],
  },
  {
    path: '/technologies',
    name: 'TechnologiesList',
    component: Technologies,
  },
  {
    path: '/technologies/:slug',
    name: 'Technology',
    component: Technology,
  },
  {
    path: '/services',
    name: 'ServicesList',
    component: Services,
  },
  {
    path: '/services/:slug',
    name: 'Service',
    component: Service,
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    children: [
      {
        path: ':slug',
        name: 'AboutSlug',
        component: About,
      },
    ],
  },
  {
    path: '*',
    name: 'Not Found',
    component: NotFound,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
